import React from 'react';
import PropTypes from 'prop-types';
import {Provider, observer} from 'mobx-react';

import InviteContent from 'spa/Pages/Invite/InviteContent';

@observer
class Invite extends React.Component {
  static propTypes = {
    params: PropTypes.shape({
      code: PropTypes.string,
    }),
  }

  render() {
    return (
      <Provider params={this.props.params}>
        <InviteContent />
      </Provider>
    );
  }
}

export default Invite;



// WEBPACK FOOTER //
// ./spa/Pages/Invite/Invite.jsx